import { useMemo } from "react";

export interface GoogleTasksSourceSettingsText {
  listsLabelText: string;
  listsPlaceholderText: string;
  listsHintText: string;
  loadingText: string;
  loadErrorText: string;
}

export const useGoogleTasksSourceSettingsText = (
  t: (key: string) => string,
): GoogleTasksSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.googleTasks.${key}`);

    return {
      listsLabelText: tKey("listsLabel"),
      listsPlaceholderText: tKey("listsPlaceholder"),
      listsHintText: tKey("listsHint"),
      loadingText: tKey("loading"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
